import { render } from "./Board.vue?vue&type=template&id=682fe8c1"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Board.vue?vue&type=style&index=0&id=682fe8c1&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__